import { render, staticRenderFns } from "./vant-select.vue?vue&type=template&id=faa71324&scoped=true&"
import script from "./vant-select.vue?vue&type=script&lang=ts&"
export * from "./vant-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa71324",
  null
  
)

export default component.exports